<app-bottom-dialog-animation [isVisible]="isVisible$ | push">
  <ng-container *rxLet="vm$; let vm">
    <form method="dialog" action ngForm class="register-fpp-claim-mobile">
      <app-header-mobile headerTitle="Start New Claim">
        <ng-container leftControls>
          <button type="button"
                  *ngIf="vm.showBackButton"
                  (click)="stepBack()"
                  mat-icon-button
                  [disabled]="vm.backBtnDisabled">
            <mat-icon>chevron_left</mat-icon>
          </button>
        </ng-container>
        <ng-container rightControls>
          <button type="button"
                  *ngIf="vm.showCloseButton"
                  (click)="close()"
                  mat-icon-button
                  [disabled]="vm.headerActionsDisabled">
            <mat-icon>close</mat-icon>
          </button>
        </ng-container>
      </app-header-mobile>
      <mat-progress-bar mode="determinate" [value]="vm.progress"></mat-progress-bar>
      <mat-dialog-content>
        <ng-container *ngComponentOutlet="vm.activeComponent"></ng-container>
      </mat-dialog-content>
      <mat-dialog-actions *ngIf="vm.showModalActions">
        <ng-template [cdkPortalOutlet]="vm.actionsPortal"></ng-template>
      </mat-dialog-actions>
    </form>
  </ng-container>
</app-bottom-dialog-animation>
